import { BKJButton, BKJLoadingSpinner } from '@bookjane2/bookjane-design-library';
import { Flex } from 'components/Flex';
import { H3, P } from 'components/Typography';
import { useTranslation } from 'hooks/useTranslation';
import {
  EmptyStateMessage,
  SkillsAllocationTableRow,
} from 'pages/Settings/pages/LocationSettings/SkillsAllocation/SkillsAllocationSettingsPage.styled';
import { useLocationSkillsStore } from 'pages/Settings/pages/LocationSettings/SkillsAllocation/store/locationSkills.store';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router-dom';
import isUserSecondarySelector from 'store/selectors/userSelectors/isUserSecondarySelector';

export const SkillsAllocationReadView: FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const match = useRouteMatch();
  const isUserSecondary = useSelector(isUserSecondarySelector);

  const appliedCommunitiesSkills = useLocationSkillsStore(
    (state) => state.appliedCommunitiesSkills,
  );
  const isLoading = useLocationSkillsStore((state) => state.isLoading);

  return (
    <Flex flexDirection="column" width="100%" maxWidth="844px">
      <Flex justifyContent="space-between" alignItems="flex-start" margin="0 0 40px 0">
        <H3>{t('settings:SKILLS')}</H3>
        {!isUserSecondary && (
          <BKJButton
            variant="PurpleOutlined"
            width="192px"
            minWidth="192px"
            onClick={() => history.push(`${match.url}/edit`)}
          >
            {t('settings:EDIT')}
          </BKJButton>
        )}
      </Flex>
      <Flex flexDirection="column" gap="32px" maxWidth="672px">
        <P>{t('location_settings:LOCATION_SKILLS_PAGE_NOTE')}</P>
        {isLoading && (
          <Flex justifyContent="center" padding="40px 0">
            <BKJLoadingSpinner variant="Default" />
          </Flex>
        )}
        {!isLoading && !appliedCommunitiesSkills.length && (
          <EmptyStateMessage>{t('location_settings:NO_APPLIED_SKILLS_MESSAGE')}</EmptyStateMessage>
        )}
        {!isLoading && !!appliedCommunitiesSkills.length && (
          <Flex flexDirection="column" width="100%">
            <SkillsAllocationTableRow $isHeader>
              {t('settings:SKILL_NAME')}
            </SkillsAllocationTableRow>
            {appliedCommunitiesSkills.map(({ skill }) => (
              <SkillsAllocationTableRow key={skill.id}>{skill.name}</SkillsAllocationTableRow>
            ))}
          </Flex>
        )}
      </Flex>
    </Flex>
  );
};
